import React from 'react';

const TableEmptyState = ({ itemName = "Data" }) => {
    return (
        <div className="flex flex-col items-center justify-center py-16 px-4 w-full animate-in fade-in duration-500">
            <div className="relative mb-6">
                {/* Abstract "Empty" Illustration with Swoodle Aesthetic */}
                <div className="w-24 h-24 bg-gradient-to-br from-[#F0FBFF] to-[#E5F7FF] rounded-3xl flex items-center justify-center shadow-sm transform transition-transform hover:scale-105 duration-300">
                    {["Merchant", "Fundraiser", "User"].includes(itemName) ? (
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#00ADEF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                        </svg>
                    ) : ["Promotion", "Promotion List"].includes(itemName) ? (
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#00ADEF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m3 11 18-5v12L3 14v-3z" />
                            <path d="M11.6 16.8l-1.6 4h-3l1.1-2.9" />
                        </svg>
                    ) : (
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#00ADEF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                            <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                            <line x1="12" y1="22.08" x2="12" y2="12" />
                        </svg>
                    )}
                    <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md border border-[#F0FBFF]">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#767676" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                    </div>
                </div>
            </div>

            <div className="text-center max-w-sm">
                <h3 className="text-[20px] font-poppins font-[600] text-[#303030] mb-2 leading-tight">
                    No {itemName} Found
                </h3>
                <p className="text-[14px] font-poppins font-[400] text-[#767676] leading-relaxed">
                    We couldn't find any {itemName.toLowerCase()} in the records. Please try again later.
                </p>
            </div>
        </div>
    );
};

export default TableEmptyState;
